import { SelectOption } from 'formComponents/Select/types';
import { useSelector } from 'react-redux';
import * as React from 'react';
// eslint-disable-next-line import/no-cycle
import { kontodefinitionenSelector } from 'store/lookups/selector';
import { callApi, Controller } from './useApi';

export interface Kontodefinition {
    recNum: number;
    bhCode: string;
    steuerCode: number;
    landKz: string;
    konto: string;
}

export const defaultKontodefinition: Kontodefinition = {
    recNum: 0,
    bhCode: '',
    steuerCode: 0,
    landKz: '',
    konto: '',
};

export function useKontodefinitionenAsOptions(): SelectOption[] {
    const kontodefinitionen = useSelector(kontodefinitionenSelector);

    return React.useMemo<SelectOption[]>(() => {
        return kontodefinitionen.map(
            (kontodefinition) =>
                ({
                    value: kontodefinition.recNum.toString(),
                    label: kontodefinition.recNum.toString(),
                } as SelectOption),
        );
    }, [kontodefinitionen]);
}

export async function addKontodefinition(kontodefinition: Kontodefinition): Promise<void> {
    return callApi<void>(Controller.kontodefinition + '/add', { kontodefinition });
}

export async function updateKontodefinition(kontodefinition: Kontodefinition): Promise<void> {
    return callApi<void>(Controller.kontodefinition + '/update', { kontodefinition });
}

export async function deleteKontodefinition(kontodefinition: Kontodefinition): Promise<void> {
    return callApi<void>(Controller.kontodefinition + '/update', { kontodefinition });
}
